module.exports = __webpack_public_path__ + "static/media/title.3a27f658.png";